/**
 *
 */
export default function getNextUnprocessedPost(posts = [], postId = null) {
  const values = postId ? reorganizePosts(posts, postId) : posts
  // @ts-expect-error TS(2339) FIXME: Property 'data' does not exist on type 'never'.
  return values.find((el) => el.data.totalPendingComments > 0) || null
}

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'postId' implicitly has an 'any' type.
function reorganizePosts(posts = [], postId) {
  const count = posts.length
  // @ts-expect-error TS(2339) FIXME: Property 'data' does not exist on type 'never'.
  const index = posts.findIndex((el) => el.data.id === postId)

  if (index < 0) {
    return []
  }

  const fPart = posts.slice(0, index)
  const lPart = posts.slice(index + 1, count)

  return lPart.concat(fPart)
}
